import { TransportScope } from "src/tmc-yard/common/model/transport.model";

export class TargetTransport {

  id: number;
  carrier: string;
  cargo: string;
  currentStation: string;
  numberPlate: string;
  trailerNumberPlate: string;
  swapTrailerNumber: string;
  transportOptions: string;
  transportScope: TransportScope;
  currentStationId: number;

  constructor(targetTransport: Partial<TargetTransport>) {
    this.id = targetTransport.id;
    this.carrier = targetTransport.carrier;
    this.cargo = targetTransport.cargo;
    this.currentStation = targetTransport.currentStation;
    this.numberPlate = targetTransport.numberPlate;
    this.trailerNumberPlate = targetTransport.trailerNumberPlate;
    this.swapTrailerNumber = targetTransport.swapTrailerNumber;
    this.transportOptions = targetTransport.transportOptions;
    this.transportScope = targetTransport.transportScope;
    this.currentStationId = targetTransport.currentStationId;
  }
}
